import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import Routers from "./routers";

function App() {
  return <Routers />;
}

export default App;
